import { mapState } from 'vuex'
import api from '@/api'

// 全局市场组织过滤
const varietyBrandMixin = {
  computed: {
    ...mapState({
      marketId: state => state.user.info.marketId,
      marketCodes: state => state.user.info.marketCodes
    }),
  },
  data () {
    return {
      brandList: [],
      attrList: [],
      varietyList: [],
    }
  },
  created () {
    !this.type && this.getVariety()
  },
  watch: {
  },
  methods: {
    // 获取品种
    getVariety () {
      const marketId = this.marketId || this.marketCodes[0]
      if (!marketId) return
      api.myStore.getVariety(marketId).then(res => {
        this.varietyList = res.data ? res.data.varietyList : []
      })
    },
    // 改变品种
    selectVarietyChange (val) {
      // 重置属性并重新获取
      this.query.goodsBrandCode = ''
      this.getVarietyAttr(val)
    },
    // 获取品种动态属性
    getVarietyAttr (varietyCode) {
      const marketId = this.marketId || this.marketCodes[0]
      if (!marketId) {
        this.$message.warning('当前客户没有市场,无法获取品种属性')
        return
      }
      api.myStore.getVarietyAttr(marketId, varietyCode).then(res => {
        this.attrList = res.data.attrList.find(item => item.attrCode === 'brand') || {}
        this.brandList = this.attrList.selList || []
      })
    },
    selectBrandChange (val) {
      const curBrand = this.brandList.find(item => item.k === val)
      const { attrCode, attrName, id } = this.attrList
      this.query.attrList = []
      this.query.attrList.push({ ...curBrand, attrCode, attrName, id })
    }
  },
}

// 报价单价校验
const checkPriceMixin = {
  data () {
    return {

    }
  },
  created () {
  },

  methods: {
    checkPrice (priceType, priceList) {
      // 阶梯价时价格需要阶梯式递增
      let preMax = 0
      let checkPrice = true
      const regInt = /^[0-9]*[1-9][0-9]*$/
      const reg2 = /^([0-9]*)(\.[\d]{1,2})?$/
      if (priceType === 'JTJ') {
        priceList.some((item, index) => {
          index !== 0 && (preMax = priceList[index - 1].min)
          if (!item.unitPrice || !regInt.test(Number(item.min)) ||
          !reg2.test(Number(item.unitPrice)) ||
          Number(preMax) >= Number(item.min) ||
          Number(item.unitPrice) > 10000000) {
            checkPrice = false
            return false
          }
        })
      }
      if (!checkPrice) {
        this.$message.warning('单价必须大于0,小于10000000,且最多两位小数;购买量必须为整数,且应呈阶梯式增长')
        return false
      }
      if (priceType === 'YKJ' &&
      (Number(priceList[0].unitPrice) <= 0 ||
      !reg2.test(Number(priceList[0].unitPrice)) ||
       Number(priceList[0].unitPrice) > 10000000)) {
        this.$message.warning('单价必须大于0,小于10000000,且最多两位小数')
        return false
      }
      return true
    }

  },
}
export { varietyBrandMixin, checkPriceMixin }
